import { Route, Routes, useMatch } from "react-router-dom";
import Inicio from "../Screens/Inicio/Inicio";
import Evento from "../Screens/Evento/Evento";
import Campus from "../Screens/Campus/Campus";
import Busqueda from "../Screens/Busqueda/Busqueda";
import Error404 from "../Screens/Inicio/404";

export default function AppRouter() {

  const env = process.env.REACT_APP_ADM_ENV;
  const pathRoot = env === "prod_server" ? "/:param1/" : "/:param1/:param2/";


  return (
    <>
<Routes>
  <Route path={pathRoot} element={<Inicio />} />
  <Route path={pathRoot+"*"} element={<Error404Route />} />
  <Route exact path={pathRoot+"evento/:eventId"} element={<Evento />} />
  <Route exact path={pathRoot+"evento/:eventId/gracias"} element={<Evento />} />
  <Route exact path={pathRoot} element={<Inicio />} />
  <Route exact path={pathRoot+"profesional/:campusId"} element={<Campus />} />
  <Route exact path={pathRoot+"busqueda"} element={<Busqueda />} />
</Routes>

    </>
  );
}

function Error404Route() {
  const match = useMatch("/*");
  return <Error404 path={match?.params["*"]} />;
}
